(function () {
var $ed731d8336f9bd9c$exports = {};
"use strict";
const $ed731d8336f9bd9c$var$contactName = document.getElementById("contact-name");
const $ed731d8336f9bd9c$var$contactEmail = document.getElementById("contact-email");
const $ed731d8336f9bd9c$var$contactMessage = document.getElementById("contact-message");
const $ed731d8336f9bd9c$var$contactMessageValidationError = document.getElementById("contact-message-validation-error");
document.getElementById("send-enquiry-button").addEventListener("click", function(e) {
    if ($ed731d8336f9bd9c$var$contactMessage.value) {
        const body = encodeURIComponent($ed731d8336f9bd9c$var$contactMessage.value) + "%0A%0A" + encodeURIComponent($ed731d8336f9bd9c$var$contactName.value);
        window.location.href = "mailto:rob@wearebookable.com?subject=Website%20Enquiry&body=" + body;
        $ed731d8336f9bd9c$var$contactName.value = "";
        $ed731d8336f9bd9c$var$contactEmail.value = "";
        $ed731d8336f9bd9c$var$contactMessage.value = "";
        $ed731d8336f9bd9c$var$contactMessageValidationError.classList.add("hidden");
    } else $ed731d8336f9bd9c$var$contactMessageValidationError.classList.remove("hidden");
});

})();
//# sourceMappingURL=index.f16a945e.js.map
